import { MenuCoverPromoLinkType, OrderClientEventName } from '@biteinc/enums';
export const orderEventSchema = {
    displayName: 'order event',
    type: 'object',
    fields: {
        name: {
            type: 'stringEnum',
            enum: OrderClientEventName,
            required: true,
        },
        createdAt: {
            type: 'timestamp',
            required: true,
        },
        data: {
            type: 'object',
            fields: {
                menuItemId: {
                    type: 'mongoId',
                },
                menuItemName: {
                    type: 'keyString',
                },
                orderSize: {
                    type: 'int',
                    min: 1,
                },
                reason: {
                    type: 'keyString',
                },
                upsellScreen: {
                    type: 'keyString',
                },
                usesFullScreenFlow: {
                    type: 'bool',
                },
                message: {
                    type: 'keyString',
                },
                code: {
                    type: 'int',
                },
                amount: {
                    type: 'int',
                },
                enable: {
                    type: 'bool',
                },
                linkType: {
                    type: 'stringEnum',
                    enum: MenuCoverPromoLinkType,
                },
                linkTarget: {
                    type: 'mongoId',
                },
            },
        },
    },
};
//# sourceMappingURL=order_event_schema.js.map